export default __webpack_public_path__ + "static/media/checkmark.6bd91d8d.png";